import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import NumberFormat from 'react-number-format';
import { Button, Col, FormGroup, Input, Label, Row, Spinner } from 'reactstrap'

const ConfigRow = ({ editRange, min: mino, max: maxo, price: priceo, id, submitting }) => {
    const [editting, setEditting] = useState(false);
    const [min, setMin] = useState(mino);
    const [max, setMax] = useState(maxo);
    const [price, setPrice] = useState(priceo);

    return (
        <Row form >
            <Col tag={FormGroup}>
                <Label>Mínimo de propiedades</Label>
                <Input type='number' disabled={!editting} value={min} onChange={({ target }) => setMin(parseInt(target.value))} min={1} />
            </Col>
            <Col tag={FormGroup}>
                <Label>Máximo de propiedades</Label>
                <Input type='number' disabled={!editting} value={max} onChange={({ target }) => setMax(parseInt(target.value))} />
            </Col>
            <Col tag={FormGroup} className='d-flex flex-column justify-content-between'>
                <Label className='text-nowrap'>Monto por propiedad en este rango</Label>
                <NumberFormat placeholder='Ingrese un monto' disabled={!editting} value={price} onValueChange={({ value }) => setPrice(value)} className='form-control' prefix='$ ' thousandSeparator fixedDecimalScale decimalScale={2} />
            </Col>
            <Col tag={FormGroup} className='d-flex align-items-end'>
                <Button color='falcon-default' className='btn-block' disabled={submitting} onClick={() => {
                    if (!editting) {
                        setEditting(true);
                    } else {
                        editRange(id, min, max, price);
                    }
                }} icon={!editting ? faEdit : faSave}>
                    {!submitting ? <FontAwesomeIcon icon={faSave} className='mr-2' /> : <Spinner size='sm' className='mr-2' />}
                    {!editting ? 'Editar' : 'Guardar'}
                </Button>
            </Col>
        </Row >
    )
}

export default ConfigRow;